import React, { useContext } from "react";
import { FixedBanner } from "@fdr/atomic-ui/_molecules/MessageV2";

import { FeedbackMessageContext } from "@fdr/utils/contextUtils";
import { BannerContainer } from "./styled-component";

// TODO: Remove Atomic-UI here.
// We can't do this new because if we change only here the rest of app will be different.
// Ideally we need to create a common component to share with others components
const HeaderFeedbackBanner = () => {
  // @ts-ignore -> Type not defined on FeedbackMessageContext, and have a lot of type inside atomic-ui, we need to refactor.
  const { bannerProps } = useContext(FeedbackMessageContext);

  return bannerProps ? (
    <BannerContainer>
      <FixedBanner {...bannerProps} />
    </BannerContainer>
  ) : null;
};

export default HeaderFeedbackBanner;
